<template>
  <li class="document">
    <div class="document__image image_library">
      <img :src="content.Thumbnail" v-if="content.Thumbnail">
    </div>
    <div class="document__content">
      {{content.Name}}
      <span class="document__meta" v-if="content.FileExtension">File type: {{content.FileExtension}}</span>
      <span class="document__meta" v-if="content.FileSize">File size: {{content.FileSize}}</span>
      <span class="document__meta" v-if="content.Resolution">Resolution: {{content.Resolution}}</span>
      <span class="document__meta" v-if="content.Keywords">Keywords: {{content.Keywords}}</span>
      <div class="document__actions">
        <button class="icon-button document__actions__button basket-green" @click="basketDocument({Id: content.Id})"></button>
        <button class="icon-button document__actions__button download-green" @click="downloadDocument({Id: content.Id})"></button>
        <button class="icon-button document__actions__button mail-green" @click="mailDocument({Id: content.Id})"></button>
      </div>
    </div>
  </li>
</template>


<script>
  import { basketDocument, mailDocument, downloadDocument } from "./DocumentsActions";

  export default {
    props: ["content"],
    vuex: {
      actions: { basketDocument, mailDocument, downloadDocument }
    }
  };
</script>


<style lang="scss">
  @import '../../assets/scss/variables.scss';
  @import '../../assets/scss/mixins.scss';

  .document{
    float: left;
    width: 50%;
    margin-bottom: 50px;

    &__meta{
      display: block;
      color: $green_light;
    }

    &__image{
      position: relative;
      float: left;
      width: 220px;
      height: 316px;
      border: 1px solid $green_dark;

      &:after{
        content: "";
        display: block;
        width: 48px;
        height: 48px;
        position: absolute;
        top: 50%;
        left: 50%;
        margin-left: -24px;
        margin-top: -24px;
        opacity: 0.3;
      }

      img{
        width: 100%;
		max-height: 100%;
        display: block;
        position: relative;
        z-index: 2;
      }
    }

    &__content{
      line-height: 24px;
      padding: 20px 40px 0 40px;
      float: left;
      width: 275px;
      box-sizing: border-box;
      color: $white;
    }

    &__actions{
      margin-top: 25px;

      &__button{
        margin-right: 11px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// DocumentsListItem.vue?73ee178c